import { Color } from './color';
/**
 * |
 */
export const Line = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'line' }, options), context);
};
Line.props = Object.assign({ defaultMarker: 'line' }, Color.props);
//# sourceMappingURL=line.js.map